<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headertoc01" class="chapter" epub:type="toc" id="toc" role="doc-toc">
<header id="headertoc01">
<h1 class="ctfm"><span aria-label="vi" class="page" id="pvi" role="doc-pagebreak"></span><span aria-label="vii" class="page" id="pvii" role="doc-pagebreak"></span>Contents</h1>
</header>
<p class="tocfmf"><a class="xref" href="#/chicrosson0008#pref">Preface</a></p>
<p class="tocf"><a class="xref" href="#/chicrosson0009#intro">Introduction</a></p>
<p class="tocpt"><a class="xref" href="#/chicrosson0010#pt01">Part One: The Depths</a></p>
<p class="tocut"><a class="xref" href="#/chicrosson0011#ut01"><span class="sm-i">INTERLUDE</span> <span class="sm-i">1:</span> <span class="sm-i">NUMBER</span> <span class="sm-i">TWENTY-ONE</span> <span class="sm-i">JUNCTION</span></a></p>
<p class="toc"><a class="xref" href="#/chicrosson0012#ch01">1   What Obeah Does Do: Religion, Violence, and Law</a></p>
<p class="tocut"><a class="xref" href="#/chicrosson0013#ut02"><span class="sm-i">INTERLUDE</span> <span class="sm-i">2:</span> <span class="sm-i">IN</span> <span class="sm-i">THE</span> <span class="sm-i">VALLEY</span> <span class="sm-i">OF</span> <span class="sm-i">DRY</span> <span class="sm-i">BONES</span></a></p>
<p class="toc"><a class="xref" href="#/chicrosson0014#ch02">2   Experiments with Justice: On Turning in the Grave</a></p>
<p class="tocut"><a class="xref" href="#/chicrosson0015#ut03"><span class="sm-i">INTERLUDE</span> <span class="sm-i">3:</span> <span class="sm-i">TO</span> <span class="sm-i">BALANCE</span> <span class="sm-i">THE</span> <span class="sm-i">LOAD</span></a></p>
<p class="toc"><a class="xref" href="#/chicrosson0016#ch03">3   Electrical Ethics: On Turning the Other Cheek</a></p>
<p class="tocpt"><a class="xref" href="#/chicrosson0017#pt02">Part Two: The Nations</a></p>
<p class="tocut"><a class="xref" href="#/chicrosson0018#ut04"><span class="sm-i">INTERLUDE</span> <span class="sm-i">4:</span> <span class="sm-i">WHERE</span> <span class="sm-i">THE</span> <span class="sm-i">GANGES</span> <span class="sm-i">MEETS</span> <span class="sm-i">THE</span> <span class="sm-i">NILE,</span> <span class="sm-i">I</span></a></p>
<p class="toc"><a class="xref" href="#/chicrosson0019#ch04">4   Blood Lines: Race, Sacrifice, and the Making of Religion</a></p>
<p class="tocut"><a class="xref" href="#/chicrosson0020#ut05"><span class="sm-i">INTERLUDE</span> <span class="sm-i">5:</span> <span class="sm-i">WHERE</span> <span class="sm-i">THE</span> <span class="sm-i">GANGES</span> <span class="sm-i">MEETS</span> <span class="sm-i">THE</span> <span class="sm-i">NILE,</span> <span class="sm-i">II</span></a></p>
<p class="toc"><a class="xref" href="#/chicrosson0021#ch05">5   A Tongue between Nations: Spiritual Work, Secularism, and the Art of Crossover</a></p>
<p class="tocpt"><a class="xref" href="#/chicrosson0022#pt03">Part Three: The Heights</a></p>
<p class="tocut"><a class="xref" href="#/chicrosson0023#ut06"><span class="sm-i">INTERLUDE</span> <span class="sm-i">6:</span> <span class="sm-i">ARLENA’S</span> <span class="sm-i">HAUNTING</span></a></p>
<p class="toc"><a class="xref" href="#/chicrosson0024#ch06">6   High Science</a></p>
<p class="tocf"><a class="xref" href="#/chicrosson0025#epil">Epilogue: The Ends of Tolerance</a></p>
<p class="tocbmf"><a class="xref" href="#/chicrosson0026#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/chicrosson0027#refs">References</a></p>
<p class="tocbm"><a class="xref" href="#/chicrosson0028#index">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-crosson-0007.vue?7e8d1e3b